export const FOCUS_RING =
    "focus-visible:outline-none focus-visible:shadow-focus"
